import { useDropzone } from "react-dropzone";
import { styled } from "@mui/material/styles";
import { Box, Button, Typography } from "@mui/material";
import { UploadFirmwareFileProps } from "./type";
import RejectionFiles from "./RejectionFiles";
import FirmwareFilePreview from "./FirmwareFilePreview";

const DropZoneStyle = styled("div")(({ theme }) => ({
    outline: "none",
    padding: theme.spacing(4, 5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.neutral,
    border: `1px dashed ${theme.palette.grey[500_32]}`,
}));

export default function UploadFirmwareFile({
    error,
    files,
    onRemove,
    onRemoveAll,
    helperText,
    sx,
    ...other
}: UploadFirmwareFileProps) {
    const { getRootProps, getInputProps, open, isDragActive, isDragReject, fileRejections } =
        useDropzone({
            noClick: true,
            noKeyboard: true,
            ...other,
        });

    return (
        <Box sx={{ width: "100%", ...sx }}>
            <DropZoneStyle
                {...getRootProps()}
                sx={{
                    ...(isDragActive && { opacity: 0.72 }),
                    ...((isDragReject || error) && {
                        color: "error.main",
                        borderColor: "error.light",
                        bgcolor: "error.lighter",
                    }),
                }}
            >
                <input {...getInputProps()} />

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        columnGap: 2,
                    }}
                >
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        Drop files here or
                    </Typography>
                    <Button size="small" variant="outlined" color="inherit" onClick={open}>
                        Select files from your computer
                    </Button>
                </Box>
                <FirmwareFilePreview
                    files={files}
                    showPreview={false}
                    onRemove={onRemove}
                    onRemoveAll={onRemoveAll}
                />
            </DropZoneStyle>

            {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}

            {helperText && helperText}
        </Box>
    );
}
